import { Children, Fragment } from "react";
/**
 * Transforms:
 * <>
 *   <Child1 />
 *   <Child2 />
 *   <>
 *     <Child3 />
 *     <Child4 />
 *   </>
 * </>
 *
 * to:
 * [<Child1 />, <Child2 />, <Child3 />, <Child4 />]
 * */
function flattenChildren(children) {
    const childrenArray = Children.toArray(children);
    return childrenArray.reduce((flatChildren, child) => {
        if (child.type === Fragment) {
            return flatChildren.concat(flattenChildren(child.props.children));
        }
        flatChildren.push(child);
        return flatChildren;
    }, []);
}
export default flattenChildren;
//# sourceMappingURL=flattenChildren.js.map